var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeletePointActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#326FAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.286 12.8574L12.8574 28.286V12.8574H28.286Z",
    fill: "#99B7D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5322 28.061L13.05 28.5432L12.3682 27.8613L12.8503 27.3792L13.5322 28.061ZM15.4607 26.1325L14.4964 27.0968L13.8146 26.4149L14.7789 25.4506L15.4607 26.1325ZM17.3893 24.2039L16.425 25.1682L15.7432 24.4863L16.7075 23.522L17.3893 24.2039ZM19.3179 22.2753L18.3536 23.2396L17.6717 22.5578L18.636 21.5935L19.3179 22.2753ZM21.2464 20.3468L20.2822 21.311L19.6003 20.6292L20.5646 19.6649L21.2464 20.3468ZM23.175 18.4182L22.2107 19.3825L21.5289 18.7006L22.4932 17.7363L23.175 18.4182ZM25.1036 16.4896L24.1393 17.4539L23.4575 16.772L24.4217 15.8078L25.1036 16.4896ZM27.0322 14.561L26.0679 15.5253L25.386 14.8435L26.3503 13.8792L27.0322 14.561ZM28.4786 13.1146L27.9964 13.5967L27.3146 12.9149L27.7967 12.4328L28.4786 13.1146Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.375 12.375H28.2857V13.3393H13.3393V28.2857H12.375V12.375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2857 11.5713C28.9959 11.5713 29.5714 12.1469 29.5714 12.857C29.5714 13.5671 28.9959 14.1427 28.2857 14.1427C27.5756 14.1427 27 13.5671 27 12.857C27 12.1469 27.5756 11.5713 28.2857 11.5713Z",
    fill: "#326FAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2854 12.0532C27.8416 12.0532 27.4819 12.4129 27.4819 12.8567C27.4819 13.3006 27.8416 13.6603 28.2854 13.6603C28.7293 13.6603 29.089 13.3006 29.089 12.8567C29.089 12.4129 28.7293 12.0532 28.2854 12.0532ZM26.5176 12.8567C26.5176 11.8803 27.309 11.0889 28.2854 11.0889C29.2619 11.0889 30.0533 11.8803 30.0533 12.8567C30.0533 13.8331 29.2619 14.6246 28.2854 14.6246C27.309 14.6246 26.5176 13.8331 26.5176 12.8567Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8571 9C14.9876 9 16.7143 10.7267 16.7143 12.8571C16.7143 14.9876 14.9876 16.7143 12.8571 16.7143C10.7267 16.7143 9 14.9876 9 12.8571C9 10.7267 10.7267 9 12.8571 9Z",
    fill: "#326FAE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8569 9.48186C10.9927 9.48186 9.48186 10.9927 9.48186 12.8569C9.48186 14.721 10.9927 16.2319 12.8569 16.2319C14.721 16.2319 16.2319 14.721 16.2319 12.8569C16.2319 10.9927 14.721 9.48186 12.8569 9.48186ZM8.51758 12.8569C8.51758 10.4602 10.4602 8.51758 12.8569 8.51758C15.2536 8.51758 17.1961 10.4602 17.1961 12.8569C17.1961 15.2536 15.2536 17.1961 12.8569 17.1961C10.4602 17.1961 8.51758 15.2536 8.51758 12.8569Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2316 11.2304C11.42 11.0422 11.7253 11.0422 11.9136 11.2304L14.4845 13.8001C14.6728 13.9884 14.6728 14.2936 14.4845 14.4818C14.2962 14.6701 13.9908 14.6701 13.8025 14.4818L11.2316 11.9121C11.0433 11.7239 11.0433 11.4187 11.2316 11.2304Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4814 11.2307C14.6696 11.4191 14.6696 11.7245 14.4814 11.9129L11.9122 14.4843C11.724 14.6727 11.4189 14.6727 11.2307 14.4843C11.0425 14.2959 11.0425 13.9905 11.2307 13.8022L13.7998 11.2307C13.9881 11.0424 14.2932 11.0424 14.4814 11.2307Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.857 27C13.5671 27 14.1427 27.5756 14.1427 28.2857C14.1427 28.9959 13.5671 29.5714 12.857 29.5714C12.1469 29.5714 11.5713 28.9959 11.5713 28.2857C11.5713 27.5756 12.1469 27 12.857 27Z",
    fill: "#326FAE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8577 27.4819C12.4138 27.4819 12.0541 27.8416 12.0541 28.2854C12.0541 28.7293 12.4138 29.089 12.8577 29.089C13.3016 29.089 13.6613 28.7293 13.6613 28.2854C13.6613 27.8416 13.3016 27.4819 12.8577 27.4819ZM11.0898 28.2854C11.0898 27.309 11.8813 26.5176 12.8577 26.5176C13.8341 26.5176 14.6256 27.309 14.6256 28.2854C14.6256 29.2619 13.8341 30.0533 12.8577 30.0533C11.8813 30.0533 11.0898 29.2619 11.0898 28.2854Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePointActive);
export default __webpack_public_path__ + "static/media/delete-point-active.007ccf5fc7ecf24c9f669ffcfbd18d22.svg";
export { ForwardRef as ReactComponent };